import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://react-burger-builder-d26ba.firebaseio.com/'
});

export default instance;